import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-maquette-dark text-white py-12" data-testid="main-footer">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info with Logo */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/logo.png"
                alt="Connected Horizon"
                className="h-14 w-auto object-contain bg-white rounded-md p-1"
              />
              <div className="flex flex-col">
                <span className="text-base font-bold leading-none">CONNECTED</span>
                <span className="text-sm font-medium leading-none text-maquette-copper">HORIZON</span>
              </div>
            </div>
            <p className="text-gray-300 text-sm">
              {language === 'fr' && 'Votre partenaire de confiance pour vos voyages et votre transformation digitale depuis Oman.'}
              {language === 'en' && 'Your trusted partner for travel and digital transformation from Oman.'}
              {language === 'ar' && 'شريكك الموثوق للسفر والتحول الرقمي من عمان.'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-4">
              {language === 'fr' ? 'Liens rapides' : language === 'en' ? 'Quick links' : 'روابط سريعة'}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm">
                  {language === 'fr' ? 'Accueil' : language === 'en' ? 'Home' : 'الرئيسية'}
                </Link>
              </li>
              <li>
                <Link to="/voyages" className="text-gray-300 hover:text-white transition-colors text-sm">
                  {language === 'fr' ? 'Agence de Voyage' : language === 'en' ? 'Travel Agency' : 'وكالة السفر'}
                </Link>
              </li>
              <li>
                <Link to="/it-services" className="text-gray-300 hover:text-white transition-colors text-sm">
                  {language === 'fr' ? 'Solutions IT' : language === 'en' ? 'IT Solutions' : 'حلول تقنية المعلومات'}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm">
                  {language === 'fr' ? 'À propos' : language === 'en' ? 'About' : 'من نحن'}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">
                  {language === 'fr' ? 'Contact' : language === 'en' ? 'Contact' : 'اتصل بنا'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info - Exact from maquette */}
          <div>
            <h4 className="text-base font-semibold mb-4">
              {language === 'fr' ? 'Contact' : language === 'en' ? 'Contact' : 'اتصال'}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span className="text-gray-300">Muscat, Oman</span>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Phone size={18} className="flex-shrink-0" />
                <a href="tel:+96617343878" className="text-gray-300 hover:text-white transition-colors">
                  +966 1734.3878
                </a>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Mail size={18} className="flex-shrink-0" />
                <a href="mailto:info@connectedhorizon.fr" className="text-gray-300 hover:text-white transition-colors">
                  info@hotcomconnectes.om
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 text-center">
          <p className="text-gray-300 text-sm">
            &copy; {currentYear} <span className="font-semibold">CONNECTED HORIZON</span>. 
            {language === 'fr' ? ' Tous droits réservés.' : language === 'en' ? ' All rights reserved.' : ' جميع الحقوق محفوظة.'}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;